import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.scss';
import App from './App';
import esES from 'antd/locale/es_ES';
import { ConfigProvider } from 'antd';
import dayjs from 'dayjs';
import updateLocale from 'dayjs/plugin/updateLocale';
import DatePickerlocale from 'antd/es/date-picker/locale/es_ES';
DatePickerlocale.lang.locale = 'es';
DatePickerlocale.lang.shortWeekDays = ['Dom', 'Lun', 'Mar', 'Mie', 'Jue', 'Vie', 'Sab'];
DatePickerlocale.lang.shortMonths = ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'];

esES.DatePicker = DatePickerlocale;
dayjs.extend(updateLocale);
dayjs.locale('es', {
  weekStart: 1,
});

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    <ConfigProvider
      locale={esES}
      theme={{
        token: {
          colorPrimary: '#22B260',
          fontFamily: "'Montserrat', sans-serif",
        },
      }}
    >
      <App />
    </ConfigProvider>
  </React.StrictMode>
);
